import { render, staticRenderFns } from "./ImageUploadByCamera.vue?vue&type=template&id=9aad12de&scoped=true&"
import script from "./ImageUploadByCamera.vue?vue&type=script&lang=js&"
export * from "./ImageUploadByCamera.vue?vue&type=script&lang=js&"
import style0 from "./ImageUploadByCamera.vue?vue&type=style&index=0&id=9aad12de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aad12de",
  null
  
)

export default component.exports